import type { Figures } from "./report-types";

function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === "object" && value !== null && !Array.isArray(value);
}

/** One number of a report's `figures` / `totals`, read by path (`"metrics", "resolution", "compliance"`); `null` when it is missing or not a number. */
export function num(figures: Figures | null | undefined, ...path: readonly string[]): number | null {
  let node: unknown = figures;
  for (const step of path) {
    if (!isRecord(node)) return null;
    node = node[step];
  }
  return typeof node === "number" && Number.isFinite(node) ? node : null;
}

/** The same, with 0 for a missing number (counts). */
export function count(figures: Figures | null | undefined, ...path: readonly string[]): number {
  return num(figures, ...path) ?? 0;
}

/** A counter object (`{ key: n }`, e.g. the CSAT reasons) as entries, biggest first. */
export function counters(figures: Figures | null | undefined, key: string): [string, number][] {
  const node = figures?.[key];
  if (!isRecord(node)) return [];
  const entries: [string, number][] = [];
  for (const [name, value] of Object.entries(node)) {
    if (typeof value === "number" && Number.isFinite(value)) entries.push([name, value]);
  }
  return entries.sort((a, b) => b[1] - a[1]);
}
